import { render, staticRenderFns } from "./BusinessOrderTasklist.vue?vue&type=template&id=673a23c2&scoped=true&"
import script from "./BusinessOrderTasklist.vue?vue&type=script&lang=js&"
export * from "./BusinessOrderTasklist.vue?vue&type=script&lang=js&"
import style0 from "./BusinessOrderTasklist.vue?vue&type=style&index=0&id=673a23c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a23c2",
  null
  
)

export default component.exports